import React from "react";
import { Dropdown, TextInput } from "hesus-ui-kit";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import { updateUnitTranslation } from "@utils/utils";
import {
  GridRow,
  APIErrorMEssage,
  LoadingContainer,
  OptionLabel,
  SectionContainer,
} from "../AddEditSolution.styled";

import { country } from "@utils/constants";

const TransportTreatment = (props) => {
  const {
    data,
    countryId,
    currencies,
    transportTypes,
    transportTypesAPIError,
    isTransportTypesLoading,
    onTransportTypeSelect,
    onTransportPriceChange,
    onTransportUnitSelect,
    onTransportCurrencySelect,
    onPollutionCommentChange,
    t,
    unitList,
    enquirySubCategoryId,
  } = props;

  return (
    <SectionContainer>
      <OptionLabel>{t("TREATMENT_AND_TRANSPORT")}</OptionLabel>
      <GridRow>
        {transportTypesAPIError !== "" && (
          <APIErrorMEssage>{transportTypesAPIError}</APIErrorMEssage>
        )}
        {isTransportTypesLoading && (
          <LoadingContainer>
            <PulseLoader color="#004c7f" />
          </LoadingContainer>
        )}
        {!isTransportTypesLoading && transportTypesAPIError === "" && (
          <Dropdown
            label={t("TRANSPORT_TYPE")}
            name="solution-dropdown-transport-type"
            value={
              data.transportType?.value
                ? parseInt(data.transportType?.value, 10)
                : ""
            }
            defaultOption={t("NONE_SELECTED")}
            containerStyles={{ marginBottom: "1.32rem" }}
            inputStyles={{ border: "1px solid #474747" }}
            options={transportTypes}
            required
            error={data.transportType.error}
            onChange={onTransportTypeSelect}
          />
        )}
      </GridRow>
      <GridRow>
        <TextInput
          type="text"
          label={t("TREATMENT_PRICE")}
          name="treatment-price"
          id="treatment-price"
          isFloat
          value={String(data.transportPrice)}
          onChange={onTransportPriceChange}
          containerStyles={{ marginTop: "1.32rem" }}
          inputStyles={{ padding: "0.43rem 0.32rem 0.43rem 0.625rem" }}
        />
        <Dropdown
          label={t("MATCHING_TREATMENT_PRICE_CURRENCY")}
          name="currency"
          value={String(data.transportCurrency.value)}
          defaultOption={t("SELECT_CURRENCY")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={currencies}
          error={data.transportCurrency.error}
          required
          onChange={onTransportCurrencySelect}
        />
        <Dropdown
          label={t("UNIT")}
          name="solution-dropdown-unit"
          value={String(data.transportUnit)}
          defaultOption={t("NONE_SELECTED")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={updateUnitTranslation(unitList, t)}
          onChange={onTransportUnitSelect}
        />
      </GridRow>
      {parseInt(enquirySubCategoryId, 10) === 1 && (
        <div style={{ marginBottom: "1.32rem" }}>
          <TextInput
            type="textarea"
            label={t("CONCERNED_POLLUTION")}
            id="pollution_comment"
            name="pollution_comment"
            value={data.pollutionComment.value}
            required={countryId === country.France}
            error={
              countryId === country.France ? data.pollutionComment.error : ""
            }
            onChange={onPollutionCommentChange}
            inputStyles={{ height: "4rem" }}
          />
        </div>
      )}
    </SectionContainer>
  );
};

TransportTreatment.propTypes = {
  countryId: PropTypes.number.isRequired,
  data: PropTypes.shape({
    transportPrice: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transportUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transportCurrency: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportType: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    pollutionComment: PropTypes.shape({
      value: PropTypes.string,
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportPriceInternalComment: PropTypes.string,
  }).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  transportTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  transportTypesAPIError: PropTypes.string.isRequired,
  isTransportTypesLoading: PropTypes.bool.isRequired,
  onTransportPriceChange: PropTypes.func.isRequired,
  onTransportUnitSelect: PropTypes.func.isRequired,
  onTransportTypeSelect: PropTypes.func.isRequired,
  onTransportCurrencySelect: PropTypes.func.isRequired,
  onPollutionCommentChange: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  enquirySubCategoryId: PropTypes.string,
};
TransportTreatment.defaultProps = {
  enquirySubCategoryId: null,
};

export default withTranslation()(TransportTreatment);
